const PRECISION = 0.0002;

const areCoordsEqual = (n1: number, n2: number) =>
  Math.abs(n1 - n2) < PRECISION;
export { areCoordsEqual };
